import z from 'zod'

import { OutletRefDto } from '@/features/outlet'

import { zh } from '@/libs/utils/zod'

export const PoStatus = z.enum(['DRAFT', 'PENDING', 'REJECT', 'DONE', 'VOID'])

export type PoStatus = z.infer<typeof PoStatus>

export const PurchaseOrderDto = z.object({
  outlet: OutletRefDto,
  source: OutletRefDto,
  code: z.string(),
  date: z.coerce.date(),
  items: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
      uom: z.string(),
      qty: z.number(),
      price: z.number(),
      subtotal: z.number(),
      note: z.string(),
    })
  ),
  note: z.string(),
  total: z.number(),
  status: PoStatus,
  ...zh.metadata.shape,
})

export type PurchaseOrderDto = z.infer<typeof PurchaseOrderDto>
